import React, { useEffect, useState } from "react";
import "./styles/MerchantScreen.css";
import { LinearGradient } from "react-text-gradients";
import SideBar from "../../Common/SideBar";
import { useDispatch, useSelector } from "react-redux";
import {
  collapseSidebar,
  expandSidebar,
} from "../../../store/reducers/sidebarSlice";
import Modal from "react-modal";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../../../config/firebase";
import { accountType, firestoreCollections } from "../../../utils";
import { errorToast, successToast } from "../../../services/toastService";
import { sendNotification } from "../../../services/firebaseService";
import {
  useDenyMerchantRequestMutation,
  useFetchMerchantActivityByIdQuery,
  useFetchUnverifiedMerchantsQuery,
  useValidateMerchantMutation,
} from "../../../services/baseQuery";
import { OvalLoader } from "../../Common/Loaders";
import ActivityLog from "./SubComponents/ModalActivityLog";

export default function MerchantRequestsScreen() {
  const sidebar = useSelector(state => state.sidebar);
  const {
    isLoading,
    isError,
    data: merchantRequests,
    error,
    isFetching,
  } = useFetchUnverifiedMerchantsQuery();

  const dispatch = useDispatch();
  // console.log(sidebar.expand, "<<< sidebar");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  // const [merchantRequests, setMerchantRequests] = useState([]);
  const [activeMerchantData, setActiveMerchantData] = useState({});
  const [approveLoading, setApproveLoading] = useState(false);
  const [denyLoading, setDenyLoading] = useState(false);
  const [declineTextAreaActive, setDeclineTextAreaActive] = useState(false);
  const [declineMerchText, setDeclineMerchText] = useState("");
  const [approveMerchant, updatedMerchant] = useValidateMerchantMutation();
  const [denyMerchant] = useDenyMerchantRequestMutation();

  const {
    isLoading: merchActivityLoading,
    isError: isFetchMerchActivityError,
    data: merchActivityData,
    error: fetchMerchActivityError,
  } = useFetchMerchantActivityByIdQuery(
    { merchantId: activeMerchantData.id },
    { skip: !activeMerchantData.id }
  );

  const handleCloseModal = () => {
    if (!approveLoading && !denyLoading) {
      setModalIsOpen(false);
      setDeclineTextAreaActive(false);
      setDeclineMerchText("");
      setActiveMerchantData({});
    }
  };

  // const fetchMerchantRequests = () => {
  //   const q = query(
  //     collection(db, firestoreCollections.merchants),
  //     where("verified", "==", false),
  //     where("profileAdded", "==", true)
  //   );

  //   const unsubscribe = onSnapshot(q, async (querySnapshot) => {
  //     const newData = await Promise.all(
  //       querySnapshot.docs.map(async (merchDoc) => {
  //         const merchantData = merchDoc.data();
  //         merchantData.category = await Promise.all(
  //           merchantData.category.map(async (categId) => {
  //             const categoryDoc = await getDoc(
  //               doc(db, firestoreCollections.merchantCategories, categId)
  //             );
  //             if (categoryDoc.exists()) {
  //               const data = categoryDoc.data();
  //               data.id = categoryDoc.id;
  //               return data;
  //             }
  //           })
  //         );

  //         return {
  //           ...merchantData,
  //           id: merchDoc.id,
  //         };
  //       })
  //     );

  //     setMerchantRequests(newData);
  //     console.log(newData);
  //   });

  //   return unsubscribe; // Return the unsubscribe function to detach the listener when needed
  // };

  // useEffect(() => {
  //   const unsubscribe = fetchMerchantRequests();

  //   return () => {
  //     unsubscribe(); // Detach the listener when the component unmounts
  //   };
  // }, []);

  const handleMerchantApprove = async merchantId => {
    if (!denyLoading) {
      try {
        setApproveLoading(true);
        // const docRef = doc(db, firestoreCollections.merchants, merchantId);
        // const updatedData = { verified: true };
        // await updateDoc(docRef, updatedData);

        await approveMerchant({ merchantId });

        const notificationData = {
          title: "Congratulations! Your profile has been verified by admin.✅",
          body: "You have now access to all the features of the application.",
          accType: accountType.MERCHANT,
          userId: merchantId,
        };
        sendNotification(notificationData);
        successToast("Merchant approved successfully.");
      } catch (error) {
        errorToast("Internal server error");
        console.log(error, "<<< error approving merchant");
      } finally {
        setApproveLoading(false);
        handleCloseModal();
      }
    }
  };

  const handleMerchantDeny = async () => {
    console.log(declineMerchText, "<<< txt");
    if (!approveLoading) {
      if (!declineMerchText) {
        errorToast("Please add reason for declining merchant request");
        return;
      }
      try {
        setDenyLoading(true);
        await denyMerchant({
          merchantId: activeMerchantData.id,
          reason: declineMerchText,
        });

        const notificationData = {
          title: "Profile Request Declined",
          body: "Please update your profile and resubmit for approval.",
          accType: accountType.MERCHANT,
          userId: activeMerchantData.merchantId,
        };
        sendNotification(notificationData);
        successToast("Merchant request rejected successfully.");
      } catch (error) {
        errorToast("Internal server error");
        console.log(error, "<<< error declining merchant");
      } finally {
        setDenyLoading(false);
        handleCloseModal();
      }
    }
  };

  return (
    <div className="MainContainer">
      <SideBar />
      <div
        style={{ width: sidebar.expand ? "84vw" : "95vw" }}
        className="ScreenContainer"
      >
        {/* upper search bar start */}

        <div className="upperSearchBarContainer">
          <div className="upperBarSearchBar">
            <div className="pageHeadingInnerContainer">
              {/* <img
                src={require("../../../assets/dashboardColourIcon.png")}
                alt="profile-pic"
                className="pageHeadingImageDashboard"
              /> */}
              <div className="pageHeading">Merchant Verification</div>
            </div>
          </div>

          <div
            className="upperBarSearchBox upperBarSearchBoxProfile"
            style={{ border: "none" }}
          >
            <img
              src={require("../../../assets/profile.png")}
              alt="profile-pic"
            />
          </div>
          <div className="upperBarSearchBox upperBarSearchBoxNotification">
            <img
              src={require("../../../assets/exit.png")}
              alt="notification-bell"
            />
          </div>
        </div>
        <div
          className="upperSearchBarContainer"
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1.5vh",
          }}
        >
          <input placeholder="Search..." className="upperBarSearchBarInput" />
          <div className="searchButton">Search</div>
        </div>
        <div className="verificationTableContainer">
          <div className="verificationTableRow">
            <div
              style={{ width: "10%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Sr. No.
            </div>
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Name
            </div>
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Phone Number
            </div>
            {/* <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Date Joined
            </div> */}
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Category
            </div>
            <div
              style={{ width: "18.75%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              Email
            </div>
            <div
              style={{ width: "15%", height: "100%" }}
              className="eachColumn eachTableHead"
            >
              View Profile
            </div>
          </div>
          {isLoading ? (
            <OvalLoader visible={true} color="#3366CC" />
          ) : (
            merchantRequests.map((item, i) => (
              <div
                className="verificationTableRow"
                key={i}
                style={{
                  backgroundColor: i % 2 == 0 ? "#6b5acd0e" : "#6b5acd1d",
                }}
              >
                <div
                  style={{ width: "10%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {i + 1}
                </div>
                <div
                  style={{
                    width: "18.75%",
                    height: "100%",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                  }}
                  className="eachColumn eachTableBody"
                >
                  {item.displayName.slice(0, 19)}
                </div>
                <div
                  style={{ width: "18.75%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item.phoneNumber}
                </div>
                {/* <div
                style={{ width: "15%", height: "100%" }}
                className="eachColumn eachTableBody"
              >
                {item.dateJoined}
              </div> */}
                <div
                  style={{ width: "18.75%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item?.category[0].name}
                </div>

                <div
                  style={{ width: "18.75%", height: "100%" }}
                  className="eachColumn eachTableBody"
                >
                  {item.email}
                </div>
                <div
                  style={{
                    width: "15%",
                    height: "100%",
                    textDecoration: "underline",
                    color: "#3366CC",
                  }}
                  className="eachColumn eachTableBody"
                  onClick={() => {
                    setActiveMerchantData(item);
                    setModalIsOpen(true);
                  }}
                >
                  Validate Merchant
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        className="modalContainer"
        ariaHideApp={false}
      >
        <div className="merchantDetailModalContainer">
          {merchActivityLoading ? (
            <OvalLoader visible={true} color="#3366CC" />
          ) : (
            <>
              <div className="merchantDetailModalProfileContainer">
                <div>
                  <img
                    // src={require("../../../assets/addProfileColoured.png")}
                    src={
                      activeMerchantData?.displayImage
                        ? `${activeMerchantData?.displayImage}`
                        : require("../../../assets/addProfileColoured.png")
                    }
                    alt="profile"
                    className="modalProfilePic"
                  />
                </div>
                <div className="modalProfileNameContainer">
                  <div
                    style={{
                      fontSize: "2vh",
                      fontFamily: "Poppins",
                      fontWeight: 600,
                    }}
                  >
                    {activeMerchantData?.displayName}
                  </div>
                  <div className="merchant-categories">
                    {activeMerchantData?.category?.map((category, index) => (
                      <span key={index} className="merchant-category-badge">
                        {category.name}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Representative's Name
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.representativeName}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Company Registration no.
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.compRegistrationNo}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Vat no.
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.vatNo}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Phone Number
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.phoneNumber}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Email
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.email}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  About Me
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.description}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Shop Address
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.address}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  Bank name
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.bankName}
                </div>
              </div>
              <div className="modalFeildContainer">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                  }}
                >
                  IBAN
                </div>
                <div
                  style={{
                    fontSize: "1.6vh",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                >
                  {activeMerchantData?.IBAN}
                </div>
              </div>
              <div className="projectGalleryMerchantModal">
                {activeMerchantData?.projectUrls?.map((uri, i) => (
                  <a
                    style={{ marginRight: "3%" }}
                    key={i}
                    href={uri}
                    target="_blank"
                  >
                    <img
                      src={uri}
                      alt="profile"
                      className="projectGalleryMerchantModalPic"
                    />
                  </a>
                ))}
              </div>
              <div className="activityLogContainer">
                <div className="modalFeildContainer">
                  <div
                    style={{
                      fontSize: "1.8vh",
                      fontFamily: "Poppins",
                      fontWeight: 600,
                    }}
                  >
                    Activity Log
                  </div>
                </div>
                {merchActivityData ? (
                  <ActivityLog activityData={merchActivityData} />
                ) : (
                  <div className="no-activity">No activity yet.</div>
                )}
              </div>
              <div className="modalButtonContainer">
                {approveLoading ? (
                  <div className="buttonEachModal buttonEachModalPrimary">
                    <div
                      style={{
                        fontSize: "1.8vh",
                        fontFamily: "Poppins",
                        fontWeight: 600,
                        color: "white",
                      }}
                    >
                      loading...
                    </div>
                  </div>
                ) : (
                  <div className="modalButtonOuterContainer">
                    <div className="modalButtonContainer">
                      <div
                        className="buttonEachModal buttonEachModalPrimary"
                        onClick={() =>
                          handleMerchantApprove(activeMerchantData.id)
                        }
                      >
                        <div
                          style={{
                            fontSize: "1.8vh",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            color: "white",
                          }}
                        >
                          Approve
                        </div>
                      </div>
                      <div
                        className="buttonEachModal buttonEachModalDecline"
                        onClick={() => setDeclineTextAreaActive(true)}
                      >
                        <div
                          style={{
                            fontSize: "1.8vh",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            color: "rgb(185, 22, 22)",
                          }}
                        >
                          Decline
                        </div>
                      </div>
                    </div>
                    {declineTextAreaActive && (
                      <>
                        <div
                          style={{
                            fontSize: "1.8vh",
                            fontFamily: "Poppins",
                            fontWeight: 600,
                            color: "black",
                            marginBottom: "1vh",
                          }}
                        >
                          Please Specify reason for decline (max. 200
                          characters) :
                        </div>
                        <textarea
                          maxLength={200}
                          className="modaDeclineTextArea"
                          placeholder="Reason"
                          onChange={e => setDeclineMerchText(e.target.value)}
                        />
                        <div className="modalButtonContainer">
                          {denyLoading ? (
                            <div className="buttonEachModal buttonEachModalPrimaryDecline">
                              <div
                                style={{
                                  fontSize: "1.8vh",
                                  fontFamily: "Poppins",
                                  fontWeight: 600,
                                  color: "white",
                                }}
                              >
                                loading...
                              </div>
                            </div>
                          ) : (
                            <div
                              className="buttonEachModal buttonEachModalPrimaryDecline"
                              onClick={handleMerchantDeny}
                            >
                              <div
                                style={{
                                  fontSize: "1.8vh",
                                  fontFamily: "Poppins",
                                  fontWeight: 600,
                                  color: "white",
                                }}
                              >
                                Decline
                              </div>
                            </div>
                          )}
                          <div
                            className="buttonEachModal buttonEachModalDecline"
                            onClick={() => {
                              if (!denyLoading) {
                                setDeclineTextAreaActive(false);
                                setDeclineMerchText("");
                              }
                            }}
                          >
                            <div
                              style={{
                                fontSize: "1.8vh",
                                fontFamily: "Poppins",
                                fontWeight: 600,
                                color: "rgb(185, 22, 22)",
                              }}
                            >
                              Cancel
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* <div className="buttonEachModal buttonEachModalSecondary">
                <div
                  style={{
                    fontSize: "1.8vh",
                    fontFamily: "Poppins",
                    fontWeight: 600,
                    color: "#03baf9",
                  }}
                >
                  Reject
                </div>
              </div> */}
              </div>
              <div onClick={handleCloseModal}>
                <img
                  src={require("../../../assets/crossIcon.png")}
                  alt="profile"
                  className="modalCross"
                />
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}
